export type PlayerSide = 'left' | 'right';

export type GameStatus = 'config' | 'countdown' | 'playing' | 'paused' | 'finished';

export type Winner = PlayerSide | 'draw' | null;

export interface Tile {
  id: number;
  value: number;
  row: number;
  col: number;
  isNew?: boolean;
  isMerged?: boolean;
}

export interface PlayerState {
  side: PlayerSide;
  board: number[][];
  tiles: Tile[];
  score: number;
  bestScore: number;
  isDead: boolean;
  hasReachedTarget: boolean;
}

export interface GameConfig {
  duration: number;
  targetScore: number;
  boardSize: number;
}

export const CONFIG_PRESETS = {
  quick: { duration: 60, targetScore: 4096, boardSize: 4 },
  standard: { duration: 180, targetScore: 8192, boardSize: 4 },
  epic: { duration: 300, targetScore: 16384, boardSize: 4 },
} as const;

export interface DualGameState {
  status: GameStatus;
  leftPlayer: PlayerState;
  rightPlayer: PlayerState;
  timeRemaining: number;
  countdownValue: number;
  winner: Winner;
  config: GameConfig;
}

export interface KeyMapping {
  [key: string]: {
    player: PlayerSide;
    direction: 'up' | 'down' | 'left' | 'right';
  };
}

export const DEFAULT_KEY_MAPPING: KeyMapping = {
  'w': { player: 'left', direction: 'up' },
  'W': { player: 'left', direction: 'up' },
  's': { player: 'left', direction: 'down' },
  'S': { player: 'left', direction: 'down' },
  'a': { player: 'left', direction: 'left' },
  'A': { player: 'left', direction: 'left' },
  'd': { player: 'left', direction: 'right' },
  'D': { player: 'left', direction: 'right' },
  'ArrowUp': { player: 'right', direction: 'up' },
  'ArrowDown': { player: 'right', direction: 'down' },
  'ArrowLeft': { player: 'right', direction: 'left' },
  'ArrowRight': { player: 'right', direction: 'right' },
};

export type GameEvent =
  | { type: 'MOVE'; player: PlayerSide; scoreDelta: number; merged: boolean }
  | { type: 'COUNTDOWN'; value: number }
  | { type: 'TICK'; remaining: number }
  | { type: 'PLAYER_DEAD'; player: PlayerSide }
  | { type: 'TARGET_REACHED'; player: PlayerSide }
  | { type: 'GAME_FINISHED'; winner: Winner; reason: 'time' | 'target' | 'death' };
